import { AxiosResponse } from "axios"
import request from "../../helpers/request"
import { TTipoMonitoria } from "./types"

export const getEquipamentos = async (tipoMonitoria: TTipoMonitoria) => {
  const url = `${process.env.REACT_APP_API}/Equipamento/ByTipo/${tipoMonitoria}`
  const result = await request({ url })
  return result.data
}

export const getUnidadeDeMedida = async () => {
  const url = `${process.env.REACT_APP_API}/Equipamento/UndMedida`
  const factory = (res: AxiosResponse) => (
    {
      ...res,
      data: res.data.map((unidade, i) => ({ id: i, unidade }))
    }
  )
  const result = await request({ url, factory })
  return result.data
}